export default __webpack_public_path__ + "static/media/SS14-min.853d4be8.png";